import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { LogNavButton } from './auth0/LogNavButton';
import { ShowCoachTools } from './auth0/ShowCoachTools';
import { NotificationBell } from './notification/NotificationBell';
import { useFeatureIsOn } from "@growthbook/growthbook-react";

export const NavMenu = () => {
    const [collapsed, setCollapsed] = useState(true);
    const isNotificationsEnabled = useFeatureIsOn("notifications");

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const handleNavLinkClick = () => {
        setCollapsed(true);
    };

    return (
        <header>
            <Navbar className="navbar-expand-lg navbar-toggleable-lg ng-white border-bottom box-shadow mb-3" container dark>
                <a href="/" className="hidden-xs hidden-sm hidden-md hidden-lg me-3">
                    <img
                        alt="logo"
                        src={process.env.PUBLIC_URL + 'logoNav.png'}
                        style={{ height: 60 }}
                        tag={Link}
                        to="/"
                    />
                </a>

                {isNotificationsEnabled && (
                    <div className="d-lg-none notification-bell-mobile">
                        <NotificationBell />
                    </div>
                )}

                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-lg-inline-flex flex-lg-row-reverse" isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow">
                        {isNotificationsEnabled && (
                            <NavItem className="d-none d-lg-block" style={{ marginRight: '10px', marginLeft: '10px', marginTop: '-5px' }}>
                                <NotificationBell />
                            </NavItem>
                        )}
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/">Home</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/practice">Practice</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/courses">Courses</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/my-rounds">My Rounds</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/round">Add round</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/stats">My Stats</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/user-profile">My Account</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={handleNavLinkClick} tag={Link} className="text-light" to="/sg-calculator">Calculator</NavLink>
                        </NavItem>
                        <ShowCoachTools onClick={handleNavLinkClick} />
                        <LogNavButton />
                    </ul>
                </Collapse>
            </Navbar>
        </header>
    );
};
